define('views/blocks/CrossSellingItemView',['hooks','jquery', 'backbone', 'app', 'SubView'
	],

    function (hooks,$, Backbone, app, SubView) {

        var CrossSellingView = Backbone.View.extend(SubView).extend({
            events: {
                'click .cross-selling__el__button, .btn-quantity, .cross-selling__el__remove':'clickUpdate',
                'click ':'removeProduct'
            },
            initialize: function () {
                var view = this;
                view.el.crossSellingItem = view;
                view.options = view.$el.data();
                view.subviews = [];
                view.render();
            },
            clickUpdate:function(e){
                e.preventDefault();
                e.stopPropagation();
                this.updateQuantity($(e.currentTarget).is('.less')?-1:1);
            },
            updateQuantity:function(offset){
                var view = this, jqxhr,
                    cart = app.getCart(),
                    id_product = view.options.id_product,
                    options = view.options,
                    currentQuantity = options.quantity,
                    targetQuantity = currentQuantity + offset,
                    badgeEl = view.$('.cross-selling__el__badge');
                toggleButtonActive(false);

                function toggleButtonActive(enabled){
                    if(!!enabled){
                        var cartProduct = cart.getProduct(id_product);
                        if(cartProduct && cartProduct.get('available_msg') === 'STOCKOUT'){
                            view.$el.attr('data-stockout','true');
                            view.$('.cross-selling__el__price').text(cartProduct.getProduct().getUnavailableMessage());
                            badgeEl.attr('data-quantity',0);
                        }
                    }
                    view.$('button').attr('disabled',!enabled)
                    view.$(offset>0?'.more':'.less').find('.circle-loader').toggleClass('playing',!enabled);
                    view.$('button.less').attr('disabled',targetQuantity<=0);
                }

                if(targetQuantity<=0){
                    jqxhr = cart.deleteProduct(id_product);
                }else{
                    jqxhr = cart.updateQuantityProduct(id_product,offset);
                }
                jqxhr.done(toggleButtonActive);
                badgeEl.attr('data-quantity',targetQuantity);
                options.quantity = targetQuantity;
            }

        });

        CrossSellingView.initializeCrossSellingItemOfView = function (view) {
            return CrossSellingView.initializeCrossSellingItemOfEl(view.$el);
        };
        CrossSellingView.initializeCrossSellingItemOfEl = function ($el) {
            var views = [];
            $el.find('.cross-selling__el').each(function ()
            {
                if(this.crossSellingItem) return;
                views.push(new CrossSellingView({el: this}));
            });
            return views;
        };

        return CrossSellingView;

    });
